export const ImageOrVid = ({mediaUrls, index, isCard, onClick, useThumbnail}:
    {mediaUrls: string[], index: number, isCard: boolean, onClick?: () => void, useThumbnail?: boolean}) => {
    if (index >= mediaUrls.length) return null;
    let url = mediaUrls[index];
    
    const isVideo = url.toLowerCase().endsWith('.mp4') || url.toLowerCase().endsWith('.mov');

    // If requested, attempt to use the thumbnail version (ONLY for images)
    if (useThumbnail && !isVideo && url.includes('storage.googleapis.com')) {
        const lastDotIndex = url.lastIndexOf('.');
        if (lastDotIndex !== -1) {
            url = url.substring(0, lastDotIndex) + '-thumb' + url.substring(lastDotIndex);
        }
    }

    if (isVideo) {
        return (
            <div>
                <video
                    controls={!isCard}
                    autoPlay={index === 0 && !isCard}
                    muted={index === 0 && !isCard}
                    playsInline
                    loop={!isCard}
                    preload={index === 0 && !isCard ? 'auto' : 'metadata'}
                    className={`w-full object-cover aspect-square rounded-xl shadow-md ${!isCard ? 'cursor-zoom-in' : ''}`}
                    onClick={onClick}
                >
                    <source src={url} type="video/mp4" />
                </video>
                {isCard && <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="bg-black bg-opacity-60 rounded-full p-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M6.5 5.5v9l7-4.5-7-4.5z" clipRule="evenodd" />
                        </svg>
                    </div>
                </div>
                }
            </div>

        );
    } else {
        return (
            <img
                src={url}
                alt="Media"
                // Only eager-load and prioritize the very first image of a card
                loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : "auto"}
                className={`w-full object-cover aspect-square rounded-xl shadow-md ${!isCard ? 'cursor-zoom-in' : ''}`}
                onClick={onClick}
                onError={(e) => {
                    const target = e.currentTarget;
                    if (target.src.includes('-thumb.')) {
                        // Fallback to high-res if thumbnail fails (e.g. for old listings)
                        target.src = target.src.replace('-thumb.', '.');
                    }
                }}
            />
        );
    }
}
